import { useModals } from 'almanac-ui/Modal'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Button } from 'blaze-ui/Button'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { BrandVisualAnalysisProcessingModal } from 'components/BrandVisualAnalysisProcessingModal/BrandVisualAnalysisProcessingModal'
import { useCreateBrandVisualAnalysis } from 'hooks/queries/brandVisualAnalyses/useCreateBrandVisualAnalysis'
import { BrandVisualKit } from 'types'
import { reportError } from 'utils/error'
import { BrandWizardVisualAnalysisModal } from 'components/BrandWizardVisualAnalysisModal/BrandWizardVisualAnalysisModal'

interface Props {
  integration?: ExternalIntegration
  onConfirm: (kit: BrandVisualKit) => void
}

export const GenerateButton = ({ integration, onConfirm }: Props) => {
  const { mutateAsync, isLoading } = useCreateBrandVisualAnalysis()
  const { openModal, closeModal } = useModals()

  const handlePress = async () => {
    if (!integration) return

    try {
      const { id } = await mutateAsync({ external_integration_id: integration.id })
      openModal(BrandVisualAnalysisProcessingModal, {
        integration,
        id,
        onConfirm,
        onSuccess: (props) => {
          closeModal()
          openModal(BrandWizardVisualAnalysisModal, props)
        },
      })
    } catch (e) {
      reportError(e)
      showErrorMessageToast('An error occurred')
    }
  }

  return (
    <Button size="lg" variant="primary" onPress={handlePress} isDisabled={!integration || isLoading}>
      Generate Brand Style
    </Button>
  )
}
